module.exports = __webpack_public_path__ + "img/history-icon.7e6933b6.svg";